import styled from 'styled-components';

export const NavItemBox = styled.div<{ isActive?: boolean }>(
  ({ theme, isActive }) => `
    padding: ${theme.spacing[4]}px;
    display: flex;
    align-items: center;
    gap: ${theme.spacing[3]}px;
    flex: 1;
    border-radius: ${theme.border.radius.medium}px;
    position: relative;
    overflow: hidden;
    background-color: ${
      isActive
        ? theme.colors.interactive.background.primary.faded
        : theme.colors.surface.background.gray.moderate
    };
    
    &:hover {
        background-color: ${
          isActive
            ? theme.colors.interactive.background.primary.faded
            : theme.colors.interactive.background.gray.highlighted
        };
    }
`,
);
